/* eslint-disable */
import { IMapset } from "~/interfaces";
import { node } from "~/util/dom";

interface ISettingMapsetProps {
	mapset: IMapset;
	selected: boolean;
	onClick: (event: MouseEvent) => void;
}

export default class SettingsMapset {
	#container: HTMLLIElement;
	#onClick: (event: MouseEvent) => void;
	#mapset: IMapset;

	constructor({
		mapset,
		selected = false,
		onClick,
	}: ISettingMapsetProps) {
		this.#mapset = mapset;
		this.#onClick = onClick;
		this.#container = node("li", { className: `settings-mapset ${selected ? "settings-mapset--selected" : ""}` });
		const imageContainer = node("div", { className: "settings-mapset__img" });
		const img = node("img", { alt: mapset.name, src: mapset.icon_url });
		imageContainer.appendChild(img);
		this.#container.appendChild(imageContainer);
		this.#container.appendChild(node("h4", { className: "settings-mapset__title", innerText: mapset.name }));
		this.#container.addEventListener("click", this.#onClick, false);
	}

	destroy() {
		this.#container.removeEventListener("click", this.#onClick, false);
	}

	get mapset() {
		return this.#mapset;
	}

	set selected(selected: boolean) {
		this.#container.classList[selected ? "add" : "remove"]("settings-mapset--selected");
	}

	get container() {
		return this.#container;
	}
};
